import React from 'react';
import styles from '../../../Run/AssessmentReview/CapabilityResponses/PageReview/PageReview.module.scss';
import StandardQuestionResponses from '../../../Run/AssessmentReview/CapabilityResponses/PageReview/StandardQuestionResponses';
import { useAssessmentReviewContext } from '../../AssessmentReviewContext';

function StandardQuestionsPageReview({ page, responses }) {
  const { questionMap } = useAssessmentReviewContext();

  return (
    <div className={styles['page-review']}>
      <StandardQuestionResponses
        page={page}
        questionMap={questionMap}
        responses={responses}
      />
    </div>
  );
}

export default StandardQuestionsPageReview;
